module.exports = __webpack_public_path__ + "static/media/ethicalAI.cb26631b.pdf";